$(function() {
	if ($("section.preguntas-frecuentes-coronita").length > 0 ) {
		$( "section.preguntas-frecuentes-coronita").each(function() {
			var faqsthis = $(this);
			controlHeightsFaqs(faqsthis, faqsthis.find(".pf-faq.pf-active"));
			faqsthis.find(".pf-faq").on("click", function(){
				var clickthis = $(this);
				if(!clickthis.hasClass("pf-active")) {
					faqsthis.find(".pf-faq").find(".video-youtube.active .video-close").trigger("click");
					faqsthis.find(".pf-faq").find(".video-youtube.active iframe").remove();
					faqsthis.find(".pf-faq").removeClass("pf-active");
					clickthis.addClass("pf-active");
					controlHeightsFaqs(faqsthis, faqsthis.find(".pf-faq.pf-active"), true);
				}
			})
		});

		$(window).resize(function() {
			$( "section.preguntas-frecuentes-coronita" ).each(function() {
				controlHeightsFaqs($(this), $(this).find(".pf-faq.pf-active"))
			})
		})
	}

	function controlHeightsFaqs(toTop, faqActiva, clicked) {
		if (window.innerWidth > 799) {
			if (clicked) {
				$('html, body').animate({
					scrollTop: toTop.offset().top
				}, 500);
			}
			var heightFaq = faqActiva.find(".pf-text-container").height()+50;
			var heightQuestions = 0;
			toTop.find(".pf-faq").each(function(){
				heightQuestions = heightQuestions + $(this).innerHeight();
			})
			if (heightQuestions > heightFaq) {
				toTop.find(".pf-container").css("height", heightQuestions);
				toTop.find(".pf-faq.pf-active .pf-text-container").css("height", heightQuestions);
			}
			else {
				toTop.find(".pf-container").css("height", heightFaq);	
			}
		}

		else {
			if (clicked) {
				$('html, body').animate({
					scrollTop: toTop.find(".pf-faq.pf-active").offset().top
				}, 500);
			}
			toTop.find(".pf-container").css("height", "auto");	
		}
	}

})